import { ctaDesc, ctaTitle } from "@/lib/seo";
// /en/translate/government — EN mirror
import QuotableStatsStrip from "@/components/QuotableStatsStrip";
import { createFileRoute } from "@tanstack/react-router";
import { CertTypeHub } from "@/components/translate/CertTypeHub";
import { getCertType } from "@/data/translation-certtypes";
import { speakableSchema, serviceWithReviewsSchema, howToSchema } from "@/lib/aeo";
import { consolidateGraph } from "@/lib/schema-graph";
import { claimReviewSchema, softwareApplicationSchema, entitySameAsSchema, COMMON_CLAIM_REBUTTALS_EN } from "@/lib/trust-schema";

const SITE = "https://nyclanguageinstitute.com";
const cert = getCertType("government")!;

export const Route = createFileRoute("/en/translate/government")({
  head: () => {
    const url = `${SITE}/en/translate/government`;
    const title = "Thai Government Document Translation — MoJ Certified | NYC";
    const desc = "Certified translations of Thai government records (house book, birth/marriage/divorce certificates. Send your documents for a free eligibility check.";
    return {
      meta: [
        { title: ctaTitle(title, "/en/translate/government", "en") }, { name: "description", content: ctaDesc(desc, "/en/translate/government", "en")},
        { name: "keywords", content: cert.keywords.join(", ") },
        { property: "og:title", content: ctaTitle(title, "/en/translate/government", "en")}, { property: "og:description", content: ctaDesc(desc, "/en/translate/government", "en")},
        { property: "og:url", content: url }, { property: "og:locale", content: "en_US" },
      ],
      links: [
        { rel: "canonical", href: url },
        { rel: "alternate", hrefLang: "en", href: url },
        { rel: "alternate", hrefLang: "th-TH", href: `${SITE}/translate/government` },
        { rel: "alternate", hrefLang: "x-default", href: `${SITE}/translate/government` },
      ],
      scripts: [
        speakableSchema(),
        howToSchema({
          name: "How NYC translates Thai government documents",
          description: cert.taglineEn,
          totalTime: "PT2D", estimatedCost: { currency: "THB", value: String(cert.priceFromThb) },
          steps: cert.stepsEn.map((s) => ({ name: s.name, text: s.text })),
        }),
        consolidateGraph([
          serviceWithReviewsSchema({ path: "/en/translate/government", serviceType: "Thai Government Document Translation", name: title, description: desc, priceFromThb: cert.priceFromThb }),
          {
            type: "application/ld+json" as const,
            children: JSON.stringify({
              "@context": "https://schema.org", "@type": "FAQPage", "@id": `${url}#faq`, inLanguage: "en",
              mainEntity: cert.faqsEn.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
            }),
          },
        ]),
        entitySameAsSchema(),
        softwareApplicationSchema({ url: `${SITE}/api/public/mcp`, name: "NYC Language Institute — MCP Server", description: "AI agent endpoint exposing Thai government document translation tooling." }),
        claimReviewSchema(COMMON_CLAIM_REBUTTALS_EN(url)),
      ],
    };
  },
  component: () => <CertTypeHub cert={cert} locale="en" />,
});
